/* eslint-disable consistent-return,max-len */
import SimpleSchema from 'simpl-schema';
import { map, pick, values } from 'lodash';

export const CONNECTOR_SUBTYPES = {
  VECTOR: 'VECTOR',
  RASTER: 'RASTER',
  POINTCLOUD: 'POINTCLOUD',
  THEMATIC: 'THEMATIC',
  GENERIC: 'GENERIC',
  properties: {
    VECTOR: {
      name: 'VECTOR',
      value: 'VECTOR',
      humanValue: 'Vector'
    },
    RASTER: {
      name: 'RASTER',
      value: 'RASTER',
      humanValue: 'Raster'
    },
    POINTCLOUD: {
      name: 'POINTCLOUD',
      value: 'POINTCLOUD',
      humanValue: 'PointCloud'
    },
    THEMATIC: {
      name: 'THEMATIC',
      value: 'THEMATIC',
      humanValue: 'Thematic'
    },
    GENERIC: {
      name: 'GENERIC',
      value: 'GENERIC',
      humanValue: 'Generic'
    }
  }
};

export const FTP_SUBTYPES = pick(CONNECTOR_SUBTYPES, [
  'VECTOR',
  'RASTER',
  'POINTCLOUD',
  'THEMATIC',
  'GENERIC'
]);

export const CONNECTOR_TYPES = {
  POSTGRESQL: 'PostgreSQL',
  properties: {
    POSTGRESQL: {
      name: 'POSTGRESQL',
      value: 'PostgreSQL',
      humanValue: 'PostgreSQL'
    }
  }
};

export const POSTGRESQL_SUBTYPES = pick(CONNECTOR_SUBTYPES, ['VECTOR', 'THEMATIC']);

export const HTTP_SUBTYPES = pick(CONNECTOR_SUBTYPES, [
  'VECTOR',
  'RASTER',
  'POINTCLOUD',
  'THEMATIC',
  'GENERIC'
]);

export const GEOJSONVT_SUBTYPES = pick(CONNECTOR_SUBTYPES, ['VECTOR']);

export const getSubTypesForType = (connectorType, resultFormat = 'array') => {
  if (resultFormat === 'object') {
    switch (connectorType) {
      case CONNECTOR_TYPES.FTP:
      case CONNECTOR_TYPES.WMS:
        return FTP_SUBTYPES;
      case CONNECTOR_TYPES.POSTGRESQL:
        return POSTGRESQL_SUBTYPES;
      case CONNECTOR_TYPES.HTTP:
        return HTTP_SUBTYPES;
      case CONNECTOR_TYPES.GEOJSONVT:
        return GEOJSONVT_SUBTYPES;
      default:
        return {};
    }
  }
  switch (connectorType) {
    case CONNECTOR_TYPES.FTP:
    case CONNECTOR_TYPES.WMS:
      return values(FTP_SUBTYPES);
    case CONNECTOR_TYPES.POSTGRESQL:
      return values(POSTGRESQL_SUBTYPES);
    case CONNECTOR_TYPES.HTTP:
      return values(HTTP_SUBTYPES);
    case CONNECTOR_TYPES.GEOJSONVT:
      return values(GEOJSONVT_SUBTYPES);
    default:
      return [];
  }
};

const componenteTypeDataSchema = new SimpleSchema({
  name: {
    type: String,
    label: 'The name to show the component',
    optional: true
  },
  show: {
    type: Boolean,
    label: 'Flag that checks if each component is shown',
    optional: true
  },
  iconFontawesome: {
    type: String,
    label: 'Icon for the button of component',
    optional: true
  },
  iconSvg: {
    type: String,
    label: 'Icon for the button of component',
    optional: true
  },
  libraryIcon: {
    type: String,
    label: 'Icon for the button of component',
    optional: true
  },
  cetegorySvg: {
    type: String,
    label: 'Icon for the button of component',
    optional: true
  }
});
export const connectorSchema = new SimpleSchema({
  createdAt: {
    type: String,
    label: 'The date this connection was created in the database',
    optional: true,
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  deleted: {
    type: String,
    label: 'The date the connection was deleted',
    optional: true,
    autoValue() {
      if (this.isInsert) return 'no';
    }
  },
  _id: {
    type: String,
    label: 'The user for the connection',
    optional: true
  },
  isOutput: {
    type: Boolean,
    label: 'Flag to check if the connector is an output one',
    optional: true
  },
  name: {
    type: String,
    label: 'A name to identify the connection',
    optional: true
  },
  owner: {
    type: String,
    label: 'The ID of the user this connection belongs to',
    optional: true
  },
  subtype: {
    type: String,
    label: 'The subtype of the connection added',
    optional: true
  },
  type: {
    type: String,
    label: 'The type of the connection added',
    allowedValues: map(CONNECTOR_TYPES.properties, 'value'),
    optional: true
  },
  updatedAt: {
    type: String,
    label: 'The date this connection was last updated',
    optional: true,
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  databaseName: {
    type: String,
    label: 'The name of the database for the connection',
    optional: true
  },
  domain: {
    type: String,
    label: 'The domain for the connection',
    optional: true
  },
  filePath: {
    type: String,
    label: 'The file path for the connection',
    optional: true
  },
  fileType: {
    type: String,
    label: 'The file type for the connection',
    optional: true
  },
  ip: {
    type: String,
    label: 'The ip address for the connection',
    optional: true
  },
  password: {
    type: String,
    label: 'The password for the connection',
    optional: true
  },
  port: {
    type: SimpleSchema.Integer,
    label: 'The port for the connection',
    optional: true,
    min: 0,
    max: 65535
  },
  schema: {
    type: String,
    label: 'The name of the schema of the database',
    optional: true
  },
  user: {
    type: String,
    label: 'The user for the connection',
    optional: true
  }
});
export const serverSchema = new SimpleSchema({
  createdAt: {
    type: String,
    label: 'The date this telemetry connection was created in the database.',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    },
    optional: true
  },
  domain: {
    type: String,
    label: 'The domain, included protocol for the server connection',
    optional: true
  },
  _id: {
    type: String,
    label: 'The ip for the telemetry connection',
    optional: true
  },
  ip: {
    type: String,
    label: 'The ip for the telemetry connection',
    optional: true
  },
  name: {
    type: String,
    label: 'A name to identify the telemetry connection.',
    optional: true
  },
  owner: {
    type: String,
    label: 'The ID of the user this telemetry connection belongs to.',
    optional: true
  },
  port: {
    type: Number,
    label: 'The port for the telemetry connection',
    optional: true
  },
  url: {
    type: String,
    label: 'The url for the telemetry connection',
    optional: true
  },
  updatedAt: {
    type: String,
    label: 'The date this telemetry connection was last updated.',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    },
    optional: true
  },
  selected: {
    type: Boolean,
    label: 'Flag to check which telemetry connection to use',
    autoValue() {
      if (this.isInsert) return false;
    },
    optional: true
  },
  serverType: {
    type: String,
    label:
      'The server Type, so far GMS/SGMS (GeoMicroServices) and DSL/SDSL (Database Server Layer)',
    optional: true
  }
});

const entWineDataSchema = new SimpleSchema({
  name: {
    type: String,
    label: 'The name to show of the entWine',
    optional: true
  },
  path: {
    type: String,
    label: 'The link of the entWine',
    optional: true
  },
  videoId: {
    type: String,
    label: 'The id of video associated at profile',
    optional: true
  },
  buffer: {
    type: String,
    label: 'The metres for profile buffer',
    optional: true
  },
  clasify: {
    type: Array,
    label: 'The names for the filtered points in profile',
    optional: true
  },
  'clasify.$': {
    type: String,
    label: 'The names for the filtered points in profile',
    optional: true
  },
  profileId: {
    type: String,
    label: 'The id of the profile asociated',
    optional: true
  },
  image: {
    type: String,
    label: 'The id of the profile asociated',
    optional: true
  },
  alias: {
    type: String,
    label: 'The id of the profile asociated',
    optional: true
  },
  disc: {
    type: String,
    label: 'The id of the profile asociated',
    optional: true
  }
});

export const settingsDownloadSchema = new SimpleSchema({
  connector: {
    type: connectorSchema,
    label: 'The server connection to use in DownloadLink.',
    optional: true
  },
  importFile: {
    type: Boolean,
    label: 'The option to show import File.',
    optional: true
  },
  server: {
    type: serverSchema,
    label: 'The server connection to use in DownloadLink.',
    optional: true
  },
  source: {
    type: Array,
    label: 'The source.',
    optional: true
  },
  'source.$': {
    type: entWineDataSchema
  }
});

export const settingsPointMapSchema = new SimpleSchema({
  connector: {
    type: connectorSchema,
    label: 'The server connection to use in DownloadLink.',
    optional: true
  },
  disc: {
    type: String,
    label: 'The server connection to use in DownloadLink.',
    optional: true
  },
  importFile: {
    type: Boolean,
    label: 'The option to show import File.',
    optional: true
  },
  server: {
    type: serverSchema,
    label: 'The server connection to use in DownloadLink.',
    optional: true
  },
  source: {
    type: Array,
    label: 'The source.',
    optional: true
  },
  'source.$': {
    type: entWineDataSchema,
    optional: true
  },
  streetViewType: {
    type: String,
    label: 'The source.',
    optional: true
  }
});

const settingsPythonSchema = new SimpleSchema({
  layerIDs: {
    type: Array,
    label: 'The array with the id layers.'
  },
  'layerIDs.$': {
    type: String,
    label: 'The id of the layers selected.'
  },
  showChangeLayer: {
    type: Boolean,
    label: 'The array with the id layers.'
  }
});

const sizeDrawerDataSchema = new SimpleSchema({
  name: {
    type: String,
    label: 'The name to show the sizeDrawer'
  },
  value: {
    type: Number,
    label: 'The value of the sizeDrawer'
  }
});

const mapTypeDataSchema = new SimpleSchema({
  name: {
    type: String,
    label: 'The name to show the component'
  },
  value: {
    type: String,
    label: 'Flag that checks if each component is shown'
  }
});

const shareOptionsSchema = new SimpleSchema({
  showShareByEmailMobile: {
    type: Boolean,
    label: 'Share map via phone and email.',
    optional: true
  },
  showPublicShare: {
    type: Boolean,
    label: 'Show share public map',
    optional: true
  },
  showPrivateShare: {
    type: Boolean,
    label: 'Show share private map',
    optional: true
  },
  showPublicUserShare: {
    type: Boolean,
    label: 'Share map with user access',
    optional: true
  },
  showPrivateUserShare: {
    type: Boolean,
    label: 'Share map with user access',
    optional: true
  },
  buttonByEmailMobile: {
    type: componenteTypeDataSchema,
    label: 'Name and icon of the button to send an email or message',
    optional: true
  }
});

const videoOptionsDataSchema = new SimpleSchema({
  name: {
    type: String,
    label: 'The name to show the component',
    optional: true
  },
  url: {
    type: String,
    label: 'The name to show the component',
    optional: true
  },
  value: {
    type: String,
    label: 'Flag that checks if each component is shown',
    optional: true
  }
});

const fileToolsDataSchema = new SimpleSchema({
  urlToUpload: {
    type: String,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  serverConnection: {
    type: Object,
    label: 'The id of the project.',
    optional: true,
    blackbox: true
  },
  geojsonFunction: {
    type: Boolean,
    label: 'The id of the project.',
    optional: true
  }
});

const directButtonsDataSchema = new SimpleSchema({
  intervalTime: {
    type: String,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  projectId: {
    type: String,
    label: 'The id of the project.',
    optional: true
  },
  savingSystem: {
    type: String,
    label: 'The annotation saving system.',
    optional: true
  },
  templates: {
    type: Array,
    label: 'The list of ids of the annotation templates.',
    optional: true
  },
  'templates.$': {
    type: String,
    label: 'The id of the templates.',
    optional: true
  },
  videoId: {
    type: String,
    label: 'The id of the video.',
    optional: true
  },
  videoOptions: {
    type: Array,
    label: 'The options of the video.',
    optional: true
  },
  'videoOptions.$': {
    type: videoOptionsDataSchema,
    label: 'The options of the video.'
  },
  enableEditTemplate: {
    type: Boolean,
    label: 'Enable edit template',
    optional: true
  },
  enableBaseDataTemplate: {
    type: Boolean,
    label: 'Enable connection with base data',
    optional: true
  },
  showConsultingData: {
    type: Boolean,
    label: 'Is show button to show data of data base',
    optional: true
  },
  limitDataConsulting: {
    type: String,
    label: 'The number to limir to show data',
    optional: true
  },
  configConnectors: {
    type: Array,
    label: 'The configurations selected each other templates',
    optional: true
  },
  'configConnectors.$': {
    type: Object,
    label: 'The configurations id selected each other templates',
    blackbox: true
  }
});
const createRouteDataSchema = new SimpleSchema({
  avoidPointsMap: {
    type: String,
    label: 'The id of the video of the points to avoid on the map',
    optional: true
  },
  buttonCreateRoute: {
    type: componenteTypeDataSchema,
    label: 'Create route button.',
    optional: true
  },
  centerOnRoute: {
    type: Boolean,
    label: 'Send location when opening the component.',
    optional: true
  },
  endPointDefault: {
    type: String,
    label: 'Final points of the create route function',
    optional: true
  },
  endPoints: {
    type: Array,
    label: 'Final points of the create route function',
    optional: true
  },
  'endPoints.$': {
    type: Object,
    label: 'Final points of the create route function',
    optional: true
  },
  'endPoints.$.name': {
    type: String,
    label: 'Type value of ViewLinksComponent',
    optional: true
  },
  'endPoints.$.button': {
    type: componenteTypeDataSchema,
    label: 'Create route button.',
    optional: true
  },
  'endPoints.$.videoId': {
    type: String,
    label: 'The id of the video of the points to avoid on the map',
    optional: true
  },
  mode: {
    type: String,
    label: 'The mode, teide.',
    optional: true
  },
  show: {
    type: Boolean,
    label: 'Flag that checks whether the create route button is displayed or not.',
    optional: true
  },
  showMode: {
    type: Boolean,
    label: 'Flag that checks whether the create route button is displayed or not.',
    optional: true
  }
});

const locationDataSchema = new SimpleSchema({
  buttonToAddIframe: {
    type: componenteTypeDataSchema,
    label: 'Name and icon of the button to send an email or message',
    optional: true
  },
  buttonToAddImage: {
    type: componenteTypeDataSchema,
    label: 'Name and icon of the button to send an email or message',
    optional: true
  },
  buttonToAddVideo: {
    type: componenteTypeDataSchema,
    label: 'Name and icon of the button to send an email or message',
    optional: true
  },
  createRouteConfiguration: {
    type: createRouteDataSchema,
    label: 'Create route configuration.',
    optional: true
  },
  buttonCurrentLocation: {
    type: componenteTypeDataSchema,
    label: 'Send location when opening the component.',
    optional: true
  },
  createAnnotationButton: {
    type: String,
    label: 'Send location when opening the component.',
    optional: true
  },
  showCreateRouteOnMap: {
    type: Boolean,
    label: 'Mostrar la funcionalidad de crear ruta o no. Teide',
    optional: true
  },
  description: {
    type: String,
    label: 'Send location when opening the component.',
    optional: true
  },
  defaultTemplate: {
    type: String,
    label: 'Send location when opening the component.',
    optional: true
  },
  changeTemplate: {
    type: Boolean,
    label: 'Send location when opening the component.',
    optional: true
  },
  goToCurrentLocation: {
    type: Boolean,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  image: {
    type: String,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  intervalTime: {
    type: String,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  projectId: {
    type: String,
    label: 'The id of the project to use in the location component.',
    optional: true
  },
  savingSystem: {
    type: String,
    label: 'The annotation saving system.',
    optional: true
  },
  searchAddress: {
    type: Boolean,
    label: 'Search the address.',
    optional: true
  },
  sendFirstLocation: {
    type: Boolean,
    label: 'Send location when opening the component.',
    optional: true
  },
  showAddress: {
    type: Boolean,
    label: 'Show the address.',
    optional: true
  },
  showSharedButton: {
    type: Boolean,
    label: 'Show the address.',
    optional: true
  },
  showAnnotation: {
    type: Boolean,
    label: 'Show information of the template.',
    optional: true
  },
  showDescription: {
    type: Boolean,
    label: 'Send location when opening the component.',
    optional: true
  },
  showImage: {
    type: Boolean,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  showName: {
    type: Boolean,
    label: 'Send location when opening the component.',
    optional: true
  },
  showTitle: {
    type: Boolean,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  showTracking: {
    type: Boolean,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  templateConfiguration: {
    type: Object,
    label: 'The configuration of the templates.',
    blackbox: true,
    optional: true
  },
  title: {
    type: String,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  trackingAnnotation: {
    type: Boolean,
    label: 'Annotations that are created whether or not they are tracked.',
    optional: true
  },
  typeComponent: {
    type: String,
    label: 'If the component is simple or complex.',
    optional: true
  },
  updatedAnnotation: {
    type: Boolean,
    label: 'Updated the annotation after created.',
    optional: true
  },
  updateAnnotationButton: {
    type: String,
    label: 'Send location when opening the component.',
    optional: true
  },
  userNameTitle: {
    type: Boolean,
    label: 'The value of the interval to create the annotation.',
    optional: true
  },
  videoId: {
    type: String,
    label: 'The id of the video to use in the location component.',
    optional: true
  },
  zoom: {
    type: Number,
    label: 'The zoom.',
    optional: true
  }
});

const selectedComponentsDataSchema = new SimpleSchema({
  AnnotationDirectButtons: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the AnnotationDirectButtons button is shown',
    optional: true
  },
  CatastroComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the CatastroComponent button is shown',
    optional: true
  },
  DownloadLinksComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the DownloadLinksComponent button is shown',
    optional: true
  },
  FileToolsComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the FileToolsComponent button is shown',
    optional: true
  },
  IntroductionMapComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the IntroductionMapComponent button is shown',
    optional: true
  },
  InfoLayerSelection: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the InfoLayerSelection button is shown',
    optional: true
  },
  ISLComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the ISLComponent button is shown',
    optional: true
  },
  LayersControl: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the LayersControl button is shown',
    optional: true
  },
  LocationComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the LocationComponent button is shown',
    optional: true
  },
  NotesComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the NotesComponent button is shown',
    optional: true
  },
  PointMapComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the PointMapComponent button is shown',
    optional: true
  },
  PythonComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the PythonComponent button is shown',
    optional: true
  },
  SentinelComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the SentinelComponent button is shown',
    optional: true
  },
  SharedComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the SharedComponent button is shown',
    optional: true
  },
  ShowMapDeckLidarComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the ShowMapDeckLidarComponent button is shown',
    optional: true
  },
  TableAnnotationsComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the TableSourceComponent button is shown',
    optional: true
  },
  TableSourceComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the TableSourceComponent button is shown',
    optional: true
  },
  ViewLinksComponent: {
    type: componenteTypeDataSchema,
    label: 'Flag that checks if the ViewLinksComponent button is shown',
    optional: true
  }
});

const intervalNotesDataSchema = new SimpleSchema({
  show: {
    type: Boolean,
    label: 'The name to show of the note interval',
    optional: true
  },
  value: {
    type: Number,
    label: 'The value of the note interval',
    optional: true
  }
});

export const notesDataSchema = new SimpleSchema({
  showOnlyTrack: {
    type: Boolean,
    label: 'showOnlyTrack',
    optional: true
  },
  showAllNotes: {
    type: Boolean,
    label: 'showAllNotes',
    optional: true
  },
  showAllTracks: {
    type: Boolean,
    label: 'showAllTracks',
    optional: true
  },
  showAnnotations: {
    type: Boolean,
    label: 'showAnnotations',
    optional: true
  },
  showTrack: {
    type: Boolean,
    label: 'showTrack',
    optional: true
  },
  showNotes: {
    type: Boolean,
    label: 'showNotes',
    optional: true
  },
  showNotesDefault: {
    type: Boolean,
    label: 'showNotes',
    optional: true
  },
  centerNotes: {
    type: Boolean,
    label: 'centerNotes',
    optional: true
  },
  centerNotesDefault: {
    type: Boolean,
    label: 'centerNotes',
    optional: true
  },
  entWine: {
    type: Array,
    label: 'entWine',
    optional: true
  },
  'entWine.$': {
    type: entWineDataSchema,
    label: 'entWine',
    optional: true
  },
  interval: {
    type: intervalNotesDataSchema,
    label: 'interval',
    optional: true
  },
  showGeomotion: {
    type: Boolean,
    label: 'showGeomotion',
    optional: true
  },
  showGeomotionPublic: {
    type: Boolean,
    label: 'showGeomotionPublic',
    optional: true
  },
  showStreetView: {
    type: Boolean,
    label: 'showStreetView',
    optional: true
  },
  showVideo: {
    type: Boolean,
    label: 'showVideo',
    optional: true
  },
  videos: {
    type: Array,
    label: 'videos',
    optional: true
  },
  'videos.$': {
    type: String,
    label: 'videos'
  },
  showCreateAnnotation: {
    type: Boolean,
    label: 'showCreateAnnotation',
    optional: true
  },
  showUpdateAnnotation: {
    type: Boolean,
    label: 'showUpdateAnnotation',
    optional: true
  },
  showDeleteAnnotation: {
    type: Boolean,
    label: 'showDeleteAnnotation',
    optional: true
  },
  showImportAnnotation: {
    type: Boolean,
    label: 'showImportAnnotation',
    optional: true
  },
  showExportAnnotation: {
    type: Boolean,
    label: 'showExportAnnotation',
    optional: true
  }
});

export const settingsAdvancedMapDataSchema = new SimpleSchema({
  tableAnnotations: {
    type: Object,
    label: 'The settings of the tableAnnotations.',
    optional: true
  },
  'tableAnnotations.videoId': {
    type: String,
    label: 'The id of the video',
    optional: true
  },
  'tableAnnotations.templateId': {
    type: String,
    label: 'The id of the template',
    optional: true
  },
  'tableAnnotations.orderElement': {
    type: Number,
    label: 'The order of the element selected.',
    optional: true
  },
  'tableAnnotations.optionList': {
    type: Array,
    label: 'The list of the options to show.',
    optional: true
  },
  'tableAnnotations.optionList.$': {
    type: String,
    label: 'The list of the options to show.'
  },
  buttonSettings: {
    type: Object,
    label: 'The settings of the buttons.',
    optional: true
  },
  'buttonSettings.shareButtonByMobile': {
    type: componenteTypeDataSchema,
    label: 'Name and icon of the button to send an email or message',
    optional: true
  },
  'buttonSettings.showAjustarMapa': {
    type: Boolean,
    label: 'Show buttons to adapt the drawer size.',
    optional: true
  },
  'buttonSettings.showDownloadLayer': {
    type: Boolean,
    label: 'Show button of download layer.',
    optional: true
  },
  'buttonSettings.showChangeSize': {
    type: Boolean,
    label: 'Show buttons to change the drawer size.',
    optional: true
  },
  'buttonSettings.showModal': {
    type: Boolean,
    label: 'Show button to open modal.',
    optional: true
  },
  'buttonSettings.templateDefault': {
    type: String,
    label: 'The default template od the advanced map.',
    optional: true
  },
  catastroSettings: {
    type: Object,
    label: 'The settings of the buttons.',
    optional: true
  },
  'catastroSettings.viewInformation': {
    type: Boolean,
    label: 'Show the information.'
  },
  'catastroSettings.streetTypeView': {
    type: String,
    label: 'Show the streetView in new window or inside the app.'
  },
  components: {
    type: selectedComponentsDataSchema,
    label: 'The components of the advanced map.',
    optional: true
  },
  downloadLinks: {
    type: settingsDownloadSchema,
    label: 'The connetion settings of the download component.',
    optional: true
  },
  defaultComponent: {
    type: String,
    label: 'The first component to show when open advancedMap',
    optional: true
  },
  directButtons: {
    type: directButtonsDataSchema,
    label: 'The first component to show when open advancedMap',
    optional: true
  },
  fileTools: {
    type: fileToolsDataSchema,
    label: 'The first component to show when open advancedMap',
    optional: true
  },
  ipsOfIsl: {
    type: Object,
    label: 'The first component to show when open advancedMap',
    optional: true,
    blackbox: true
  },
  locationSettings: {
    type: locationDataSchema,
    label: 'The settings of the location component.',
    optional: true
  },
  mapTypes: {
    type: Array,
    label: 'The list of map types.',
    optional: true
  },
  'mapTypes.$': {
    type: mapTypeDataSchema,
    label: 'An object containing the list of map types.'
  },
  notes: {
    type: notesDataSchema,
    label: 'An object with the settings of Notes Component',
    optional: true
  },
  tableSource: {
    type: Object,
    label: 'An object with the settings of TableSource Component',
    optional: true,
    blackbox: true
  },
  // { defaultSource: '', sources: [] },
  orderOfComponents: {
    type: Array,
    label: 'List of components in order.',
    optional: true
  },
  'orderOfComponents.$': {
    type: String,
    label: 'Each component in order.'
  },
  pointMap: {
    type: settingsPointMapSchema,
    label: 'The connetion settings of the download component.',
    optional: true
  },
  pythonSettings: {
    type: settingsPythonSchema,
    label: 'The settings of the python component.',
    optional: true
  },
  sizeDrawer: {
    type: sizeDrawerDataSchema,
    label: 'The size of the drawer.',
    optional: true
  },
  shareOptions: {
    type: shareOptionsSchema,
    label: 'Send location when opening the component.',
    optional: true
  },
  showTooltip: {
    type: Boolean,
    label: 'Show tooltip.',
    optional: true
  },
  textSettings: {
    type: Object,
    label: 'The settings of the text.',
    optional: true
  },
  'textSettings.logoHeight': {
    type: Number,
    label: 'The size of the logo.',
    optional: true
  },
  'textSettings.title': {
    type: Number,
    label: 'The size of title.'
  },
  'textSettings.description': {
    type: Number,
    label: 'The size of the description.',
    optional: true
  },
  'textSettings.descriptionHeight': {
    type: Number,
    label: 'The size of the description.',
    optional: true
  },
  'textSettings.font': {
    type: String,
    label: 'Font text in IntroductionComponent'
  },
  'textSettings.logo': {
    type: String,
    label: 'The url of the logo in IntroductionComponent',
    optional: true
  },
  'textSettings.showTitle': {
    type: Boolean,
    label: 'The url of the logo in IntroductionComponent',
    optional: true
  },
  'textSettings.showImagen': {
    type: Boolean,
    label: 'The url of the logo in IntroductionComponent',
    optional: true
  },
  viewLinks: {
    type: Array,
    label: 'Array with the values of ViewLinksComponent',
    optional: true
  },
  'viewLinks.$': {
    type: Object,
    label: 'Objet of the link list.'
  },
  'viewLinks.$.type': {
    type: String,
    label: 'Type value of ViewLinksComponent'
  },
  'viewLinks.$.value': {
    type: String,
    label: 'Url value of ViewLinksComponent'
  },
  'viewLinks.$.name': {
    type: String,
    label: 'Url value of ViewLinksComponent'
  }
});
